// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Jfrr","bigColWidth":"Table_bigColWidth__mEUEc","biggerColWidth":"Table_biggerColWidth__1Rb6c","row":"Table_row__3yyFg","col":"Table_col__1uYNN"};